
(function (window, document, jQuery, undefined) {
    var $ = jQuery.noConflict();
    var $widget = $(".don-teaser-pager").first();
    var $teasers = $widget.find(".don-teaser-pager__teaser");
    var $btns = $widget.find(".don-pagination__page-link");
    var $pagination = $widget.find(".don-pagination");    

    $.each($btns, function ApplyBtnClickHandler(index, btn) {        
        $btn = $(btn);
        $btn.click(function Btn_Clicked(e) {
            $this = $(this);
            var pageToShow = 1;

            if ($this.data("show") === "prev") {
                pageToShow = $pagination.data("current") - 1;
                if (pageToShow < 1) {
                    pageToShow = $pagination.data("current");
                }
            }
            else if ($this.data("show") === "next") {
                pageToShow = $pagination.data("current") + 1;
                if (pageToShow > $pagination.data("pages")) {
                    pageToShow = $pagination.data("current");
                }
            }
            else {
                pageToShow = $this.data("show"); 
            }

            $pagination.data("current", pageToShow);

            $.each($teasers, function ToggleTeaser(index, teaser) {
                $teaser = $(teaser);
                if ($teaser.data("page") === pageToShow) {
                    $teaser.fadeIn(300);
                }
                else {
                    $teaser.fadeOut(300);
                }
            });

            $(".don-pagination__page-item")
                .removeClass("active");
            $('.don-pagination__page-item[data-show="' + pageToShow + '"]')
                .addClass("active");

            window.location =
                window.location.href.split('#')[0] + '#don-teaser-pager__top';
        }); 
    });
})(window, document, jQuery);
